/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from "classnames";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { withTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { Component } from "react";
import { renderHTML } from "../../../../../util/DomHelper";
import styles from "./Faq.module.scss";

const propTypes = {
  filterFaq: PropTypes.array.isRequired,
};

class FAQ extends Component {
  constructor(props: any) {
    super(props);

    this.state = {
      questionAnswer: [],
    };
  }

  componentDidMount() {
    this.fetchAnswersDetail();
  }

  fetchAnswersDetail = () => {
    const { filterFaq = [] } = this.props;
    this.setState({ questionAnswer: filterFaq });
  };

  render() {
    const {
      questionAnswer,
    } = this.state;
    const answersLength = questionAnswer ? questionAnswer.length : 0;
    return (
      <>

        {answersLength > 0 && (
          <div style={{ display: "flex", flexDirection: "column" }}>

            <div>
              <div className="text-left">
                {questionAnswer.map((eachQuestionAnswer: any, index: any) => (
                  <div
                    className={` ${styles.question_answer_container}`}
                    key={index}
                  >
                    <div className="text-left">

                      <PAText
                        component="h4"
                        fontSize={FONT_SIZE[1]}
                        bold
                        className={classNames("m-b-0", {
                          "m-t-20": index !== 0,
                        })}
                        color="black"
                      >
                        {eachQuestionAnswer.question}
                      </PAText>
                    </div>

                    <div key={index}>

                      <div className="p-t-5 p-b-5 m-b-10">
                        {eachQuestionAnswer.answer && (
                          <PAText component="h5">
                            {eachQuestionAnswer.answer}
                          </PAText>
                        )}
                        {eachQuestionAnswer.article && (
                          <div
                            className={`${styles.html_answer}`}
                            dangerouslySetInnerHTML={renderHTML(eachQuestionAnswer.article)}
                          />
                        )}

                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

      </>
    );
  }
}

FAQ.propTypes = propTypes;
export default withTranslation("common")(FAQ);
